module.exports = __webpack_public_path__ + "static/media/crowdplat-thumb.3ca5c10f.png";